import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class ThreeButtons extends DesigntimeComponent {
    static staticName = "Buttons (1-3)";
    static staticId = "threeButtons";
    runtimeValue = null;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            header: new LiquidString("text", `${this.id}_header`),
            button1: { value: "Less" },
            button2: { value: "Same" },
            button3: { value: "More" },
            buttontext: { value: "Next" },
            nextOnClick: { value: "false", dontTranslate: true, description: "Set to 'true' if next component should be shown without next-button click" }
        };
    }

    getRuntimeView(context) {
        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView();

        var $view = $("<div></div>");
        $view.append(this.values.header.getTag("h3"))

        $view.append(this.getButton(this.values.button1.value, 1));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button2.value, 2));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button3.value, 3));
        $view.append($("<br />"));

        return $view;
    }

    getButton(buttonText, buttonValue) {
        var $button = $(`<input class='sid-question-button' type='button' value='${buttonText}' data-result='${buttonValue}'></input >`);
        $button.on("click", function (e) {
            componentHelpers.getRtFrame(this.id).find(".sid-question-button").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.runtimeValue = $(e.currentTarget).data("result");
            this.enableNextButton();
        }.bind(this));
        return $button;
    }

    getRuntimeBootstrapView() {
        var $view = $("<div class='mb-4 content-three-buttons'></div>");

        if (this.values.header.value) {
            $view.append(this.values.header.getTag("h3"))
        }

        $view.append(this.getBootstrapButton(this.values.button1.value, 1));
        $view.append(this.getBootstrapButton(this.values.button2.value, 2));
        $view.append(this.getBootstrapButton(this.values.button3.value, 3));

        return $view;
    }

    getBootstrapButton(buttonText, buttonValue) {

        let buttonclasses = componentHelpers.getButtonClasses();

        var $button = $(`<button type='button' class='${buttonclasses}' data-result='${buttonValue}'>${buttonText}</button>`);
        if (this.values.nextOnClick.value == "true")
            $button.addClass("internal-next-button");
        $button.on("click", function (e) {
            componentHelpers.getRtFrame(this.id).find("button").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.runtimeValue = $(e.currentTarget).data("result");
            this.enableNextButton();
        }.bind(this));
        return $button;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
        };
    }

    output = [
        { name: "value", type: "number" }
    ];
}

export { ThreeButtons }
